import { createAction } from "@reduxjs/toolkit";
import SpectralModel from "spectral-core/models/SpectralModel";

export const setApplicationsAction =
  createAction<SpectralModel[]>("SET_APPLICATIONS");
export const setApplicationsLogoutAction = createAction("LOGOUT");
